import React, { useEffect, useState } from "react";
import "./Product_Listing_Page.css";
import All_Vegitables_category_slider from "./all_vegitables_category_slider/All_Vegitables_Category_Slider";

import { Nav, Tab } from "react-bootstrap";
import Top_Filter_Div from "./top_filter_div/Top_Filter_Div";
import Product_Info_Grid_View from "../common_components/product_info_grid_view/Product_Info_Grid_View";
import Shop_Banner from "../shop/shop_banner/Shop_Banner";
import Product_Info_List_View from "../common_components/product_info_list_view/Product_Info_List_View";
import { useDispatch, useSelector } from "react-redux";
import { getAllCategories } from "../../features/master/masterSlice";
import { getAllProducts } from "../../features/products/productsSlice";
import { useLocation, useParams } from "react-router-dom";
import All_Vegitables_subCategory_Slider from "./all_vegitables_category_slider/All_Vegitables_subCategory_Slider";
import Common_Heading_Holder from "../common_components/common_heading_holder/Common_Heading_Holder";
import { getAllWishlist } from "../../features/wishlist/wishlistSlice";

const Product_Listing_Page_SubCategory = () => {
  const products = [
    {
      product_name: "Nescafe Classic",
      img: "/assets/images/products/img6.png",
      sub_text: "Price per kg",
      rating: "4.5",
      selling_price: "₹ 120.00",
      mrp: "₹ 150.00",

      discount: "10",
      outOfStock: false,
      company: "Nescafe",
    },

    {
      product_name: "Nescafe Classic",
      img: "/assets/images/products/img6.png",
      sub_text: "Price per kg",
      rating: "4.5",
      selling_price: "₹ 120.00",
      mrp: "₹ 150.00",
      discount: "10",
      outOfStock: true,
      company: "Kellog's",
    },

    {
      product_name: "Nescafe Classic",
      img: "/assets/images/products/img6.png",
      sub_text: "Price per kg",
      rating: "4.5",
      selling_price: "₹ 120.00",
      mrp: "₹ 150.00",
      discount: "10",
      outOfStock: false,
    },

    {
      product_name: "Nescafe Classic",
      img: "/assets/images/products/img6.png",
      sub_text: "Price per kg",
      rating: "4.5",
      selling_price: "₹ 120.00",
      mrp: "₹ 150.00",
      discount: "10",
      outOfStock: false,
    },

    {
      product_name: "Nescafe Classic",
      img: "/assets/images/products/img6.png",
      sub_text: "Price per kg",
      rating: "4.5",
      selling_price: "₹ 120.00",
      mrp: "₹ 150.00",
      discount: "10",
      outOfStock: false,
    },

    {
      product_name: "Nescafe Classic",
      img: "/assets/images/products/img6.png",
      sub_text: "Price per kg",
      rating: "4.5",
      selling_price: "₹ 120.00",
      mrp: "₹ 150.00",
      discount: "10",
      outOfStock: false,
    },

    {
      product_name: "Nescafe Classic",
      img: "/assets/images/products/img6.png",
      sub_text: "Price per kg",
      rating: "4.5",
      selling_price: "₹ 120.00",
      mrp: "₹ 150.00",
      discount: "10",
      outOfStock: false,
    },

    {
      product_name: "Nescafe Classic",
      img: "/assets/images/products/img6.png",
      sub_text: "Price per kg",
      rating: "4.5",
      selling_price: "₹ 120.00",
      mrp: "₹ 150.00",
      discount: "10",
      outOfStock: false,
    },
  ];
  const [selectedOption, setSelectedOption] = useState([]);

  const [subCategoryId, setSubCategoryId] = useState(null);

  const { id } = useParams();
  const dispatch = useDispatch();

  const allProducts = useSelector((state) => state.product.allProducts);
  useEffect(() => {
    dispatch(
      getAllProducts({
        // category_id: id,
        subcategory_id: id,
        priceOrder: selectedOption || "",
      }),
    );
  }, [dispatch, id, selectedOption]);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const categoryName = searchParams.get("category_name");

  const categoryImage = searchParams.get("category_image");

  const receivedData = location.state?.data;
  const headingText = location.state?.headingText;
  useEffect(() => {
    dispatch(getAllWishlist());
  }, []);
  return (
    <section className="Product_Listing_Page">
      <Tab.Container id="left-tabs-example" defaultActiveKey="Grid">
        {/* <Top_Filter_Div
          pageTitle={categoryName}
          selectedOption={selectedOption}
          setSelectedOption={setSelectedOption}
        /> */}

        <div className="container">
          {/* <All_Vegitables_subCategory_Slider
            categoryImage={categoryImage}
            categoryId={id}
            setSubCategoryId={setSubCategoryId}
          /> */}

          <div className="titlediv">
            <Common_Heading_Holder headingText={headingText} />
          </div>

          <Tab.Content>
            <Tab.Pane eventKey="Grid">
              <div className="row">
                {receivedData?.length > 0 ? (
                  receivedData.map((product) => {
                    return (
                      <div
                        key={product.id}
                        className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12 mb-5 custom_col"
                      >
                        <Product_Info_Grid_View product={product} showQty />
                      </div>
                    );
                  })
                ) : (
                  <div
                    style={{
                      textAlign: "center",
                      padding: "20px",
                      fontWeight: "bold",
                      width: "100%",
                    }}
                  >
                    Product Not Available
                  </div>
                )}
              </div>
              {/* <div className="shop_banner_holder">
                <Shop_Banner />
              </div> */}
            </Tab.Pane>
            <Tab.Pane eventKey="List">
              {allProducts?.length > 0 ? (
                allProducts.map((product) =>
                  subCategoryId === product?.p_sub_category_id ? (
                    <Product_Info_List_View
                      key={product.id}
                      products={product}
                      showQty
                    />
                  ) : subCategoryId === null ? (
                    <Product_Info_List_View
                      key={product.id}
                      products={product}
                      showQty
                    />
                  ) : null,
                )
              ) : (
                <div
                  style={{
                    textAlign: "center",
                    padding: "20px",
                    fontWeight: "bold",
                  }}
                >
                  Product Not Available
                </div>
              )}
            </Tab.Pane>
          </Tab.Content>
        </div>
      </Tab.Container>
    </section>
  );
};

export default Product_Listing_Page_SubCategory;
